
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/naming-convention */
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { MyConstants } from '@app/core/constants/constants';

import { DataService } from '@app/core/services/data.service';
import { SubSink } from '@app/core/subsink';
import { NgSelectConfig } from '@ng-select/ng-select';
import dayjs from 'dayjs/esm';

import { ITagItemProperti } from '@app-reports/interfaces/tag-items-property.interface';
import { debounce, interval } from 'rxjs';

// import { CreateCustomReportComponent } from '@app-reports/custom-reports/create/create-custom-report.component';

@Component({
    selector: 'app-tag-report-filters',
    templateUrl: './tag-report-filters.component.html',
    styleUrls: ['./tag-report-filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TagReportFiltersComponent implements OnInit {

    @Input() public showFilterPanel: boolean;

    @Output() public tagFilterModel: any;
    @Output() exportTagFilterModel = new EventEmitter();

    public searchModel!: FormGroup;

    public selectedDate: any;

    public locale: any;
    public ranges: any;
    public maxDate: any;
    public minDate: any;
    public isRequesting: boolean = false;
    public isRangeSelection: boolean;

    public selectedItems: any;

    public tagItemTemplateData: ITagItemProperti[] = [];

    public searchTerms: string = '';
    public NouisliderConfig: any;

    private filterModel: any = {};

    private subs = new SubSink();
    constructor(
        private config: NgSelectConfig,
        private _formBuilder: FormBuilder,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,

        private dataService: DataService,
    ) {
        this.config.notFoundText = 'Custom not found';
        this.config.appendTo = 'body';
        this.config.bindValue = 'value';

        this.locale = {
            format: this.getPageTitle('SYSTEM.DATE_FORMAT'), // could be 'YYYY-MM-DDTHH:mm:ss.SSSSZ'
            displayFormat: this.getPageTitle('SYSTEM.DATE_FORMAT'), // default is format value
            direction: 'ltr',
            weekLabel: 'W',
            separator: this.getPageTitle('CALENDAR.SEPARATOR'),
            cancelLabel: this.getPageTitle('SYSTEM.RECORD.CANCEL'),
            applyLabel: this.getPageTitle('SYSTEM.RECORD.OK'),
            clearLabel: this.getPageTitle('SYSTEM.RECORD.CLEAR'),
            customRangeLabel: this.getPageTitle('CALENDAR.CUSTOM'),
            firstDay: 1,
        };

        this.ranges = MyConstants.calendarRanges;

        this.minDate = new Date(1945, 1, 1);
        this.maxDate = new Date();

        this.NouisliderConfig = {};

        this.selectedDate = {
            startDate: dayjs().subtract(7, 'days'),
            endDate: dayjs().toDate(),
        };

        this.setFilterModel();
    }

    ngOnInit(): void {
        this.loadParameters();
    }

    get filterQueryData() { return this.searchModel.get('filterQuery') as FormArray; }

    public loadParameters(): void {

        this.subs.add(
            this.dataService
                .getAny('tag-item-property/get-tag-property-template')
                .subscribe((response: any) => {

                    this.tagItemTemplateData = response as ITagItemProperti[];

                }, (error: HttpErrorResponse) => {
                    console.log('error', error);
                })
        );
    }

    public onSelectionChange($event): void {
        console.log($event);
    }

    public onChangeQuerySelector(i: number, $event: any): void {

        console.log($event);
    }

    public getPageTitle(text: string): string {
        return this.dataService.getTranslated(text);
    }
    public formatLabel(value: number): any {
        if (value >= 1000) {
            return Math.round(value / 1000) + 'k';
        }

        return value;
    }

    public trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    public chosenDateTime(e: any): void {

        if (e.startDate === null && e.endDate === null) { return; }

        this.searchModel.controls.startDate.setValue(new Date(e.startDate));
        this.searchModel.controls.endDate.setValue(new Date(e.endDate));
    }

    public prepareDefaultToObject(data: any): any {
        let item = '';
        const result: any = [];

        if (data !== null) {
            data = data.split(',');
            for (let i = 0; i < data.length; i++) {
                item = data[i].trim();
                result.push({ name: item });
            }
        }
        return result;
    }

    public addFilterQuery(): void {
        this.filterQueryData.push(
            this._formBuilder.group({
                name: [null],
                value: [null],
                valueEnd: [null],
                valueType: [null]
            })
        );
    }

    public removeFilterQuery(index: number): void {
        // const selectorFormArray = this.searchModel.get('filterQuery') as FormArray;
        this.filterQueryData.removeAt(index);
    }

    public filterData(): void {

        const typeProperties: any = this.searchModel.controls.filterQuery.value;

        const properties: any = typeProperties.map((item: any) => ({
            propertyTemplateId: item.name?.id,
            value: item.value.length > 0 ? item.value[0] : item.value,
            valueEnd: item.value.length > 0 ? item.value[1] : null,
            valueType: item.name?.valueType
        }));

        this.searchModel.controls.filterSpecifications.setValue(properties);

        this.filterModel = this.searchModel.value;
        this.dataService.tagItemPropertiesSearchPanel.next(this.searchModel.value);

    }

    // public getStartValue($event: any): void {
    // }

    // public getEndValue($event: any): void {
    // }

    public clearSearchModel(): void {
        this.searchModel.reset();
        this.setFilterModel();
    }

    public exportTagFilterClick(value: any): void {
        this.exportTagFilterModel.emit(value);
    }

    private setFilterModel(): void {
        this.searchModel = this._formBuilder.group({
            searchTerm: [null],
            startDate: [null, Validators.compose([Validators.required])],
            endDate: [null, Validators.compose([Validators.required])],
            filterQuery: this._formBuilder.array([]),
            filterSpecifications: null,
            pageIndex: 1,
            pageSize: 10
        });

        this.searchModel.controls.startDate.setValue(new Date(this.selectedDate.startDate));
        this.searchModel.controls.endDate.setValue(new Date(this.selectedDate.endDate));

        this.exportTagFilterClick(this.searchModel.value);

        this.searchModel.valueChanges
            .pipe(
                debounce(() => interval(500))
            )
            .subscribe((value: any) => {

                this.exportTagFilterClick(value);
                // this.dataService.tagItemPropertiesSearchPanel.next(value);

            });
    }

}
